import { SANDBOX } from "@/shared/utils/config"
import { ANIMALIS_CONTEST_PREVIEW_STORAGE_KEY } from "@/shared/utils/animalis-contest"
import { useSearchParams } from "next/navigation"
import { useEffect, useState } from "react"

/**
 * QA-only override for the Animalis contest banner (DLM-1775). On non-production
 * environments only:
 *   - `?animalis_contest=preview` turns the preview on (persisted so it survives
 *     the marketing redirect and step navigation),
 *   - `?animalis_contest=off` turns it back off.
 *
 * When on, it forces the campaign window "active" so the banner can be reviewed
 * outside September. It does NOT bypass the Animalis-traffic requirement — the
 * quote must still come from the Animalis landing page (`referrer_type ===
 * "animalis"`). Always returns `false` in production.
 *
 * Read from anywhere that displays the banner; the flag is captured from the URL
 * on whichever page carries the query param and mirrored to localStorage.
 */
export function useAnimalisContestPreview(): boolean {
  const searchParams = useSearchParams()
  const [enabled, setEnabled] = useState(false)

  useEffect(() => {
    if (!SANDBOX) return
    const param = searchParams.get("animalis_contest")
    if (param === "preview") localStorage.setItem(ANIMALIS_CONTEST_PREVIEW_STORAGE_KEY, "1")
    else if (param === "off") localStorage.removeItem(ANIMALIS_CONTEST_PREVIEW_STORAGE_KEY)
    // eslint-disable-next-line react-hooks/set-state-in-effect -- read a client-only external store (localStorage) into React state on mount
    setEnabled(localStorage.getItem(ANIMALIS_CONTEST_PREVIEW_STORAGE_KEY) === "1")
  }, [searchParams])

  return enabled
}
